<template>
  <div class="home">
    <div class="navbar" id="nav" style="padding-top: 30px ">
      <a href="#" v-scroll-to="'#nav'" class="no-item">
        <h2 class="nav-title">
          <img class="nav-logo" src="@/assets/img/GD_PNG_WHITE.png" /> L2jGabDev
        </h2></a
      >

      <div class="nav-right">
        <a href="#" v-scroll-to="'#mods'" class="nav-item borderFade">MODS</a>
        <a href="#" v-scroll-to="'#contact'" class="nav-item borderFade"
          >CONTACT</a
        >
      </div>
    </div>
    <v-container class="center-column" style="height: inherit;">
      <img class="logo" src="@/assets/img/GD_PNG_WHITE.png" />
      <div class="center">
        <Typer
          :words="[
            'L2j',
            'Mod or Event developer',
            'Bugs fixing',
            'New Addons',
            'Great Support',
          ]"
        />
      </div>

      <div class="center" style="margin-top: 10px">
        <a href="" class="icon-social">
          <v-icon large color="#7289DA" dark>
            mdi-discord
          </v-icon>
        </a>
        <a href="" class="icon-social">
          <v-icon large color="#00AFF0" dark>
            mdi-skype
          </v-icon>
        </a>
        <a href="" class="icon-social">
          <v-icon large color="#3b5998" dark>
            mdi-facebook
          </v-icon>
        </a>
      </div>
      <div class="icon-scroll"></div>
    </v-container>

    <div style="height: 200px"></div>
    <section id="mods" class="sect">
      <h1 class="section-title">MODS</h1>
      <h2 class="para">The only seller of these files is <b>'gabsoncs'</b> on discord. If you got in contact with any other person be aware!</h2>
      <h2 class="para">A H5 project with everything included is also available. DM on discord for more info.</h2>
      <p class="para">You can find all the mods bellow. Written for H5. Can be addapted for any Chronicle and any l2j pack.</p>
      <p class="para">For any other job, addon, event, adaptation, please contact me.</p>
      <ModalImage :imgs="img" :dialog="dialog" style="position: relative" @close-modal="dialog = false"/>
      <div class="mods">
        <Mod v-for="(mod, index) in mods" :key="index" :mod="mod" @image-object="changeImage"/>
      </div>
    </section>

    <section id="contact" class="sect" style="padding-top: 150px;">
        <h1 class="section-title">CONTACT ME</h1>
      <!-- <p class="para">custom text pls</p> -->

      <div class="mods">
        <a class="social-button discord">
          <v-icon x-large color="white" dark>
            mdi-discord
          </v-icon>
          <p class="social-name">gabsoncs</p>
        </a>
        <a class="social-button skype">
          <v-icon x-large color="white" dark>
            mdi-skype
          </v-icon>
          <p class="social-name">gabriel_costa25@hotmail.com</p>
        </a>
        <a
          href="https://www.facebook.com/l2jgabdev/"
          class="social-button facebook"
        >
          <v-icon x-large color="white" dark>
            mdi-facebook
          </v-icon>
          <p class="social-name">@l2jgabdev</p>
        </a>
      </div>
    </section>
    <footer class="cust-footer">
      <h4 class="copy-text">© 2020-2025 L2jGabDev</h4>
      <h5 class="copy-text">Made with ❤️ by Issam and Gabriel</h5>
    </footer>
  </div>
</template>

<script>
import Typer from "@/components/Typer.vue";
import Mod from "@/components/Mods.vue";
import ModalImage from "@/components/ModalImage.vue";
import gab from "../services/gabs.js"

export default {
  name: "Home",
  data: () => ({
    dialog: false,   
    img: null, 
    mods: [
    ],
  }
  ),  
  ready() {
  },
  mounted () {
    this.mods = gab.getMods();   
  },
  components: { Typer, Mod, ModalImage },
  methods: {
    changeImage (image) {
      this.img = image
      if(this.dialog)
        this.dialog = false;
      this.dialog = true;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.home {
  background: rgb(33, 29, 73);
  background: linear-gradient(0deg, rgba(33, 29, 73, 1) 0%, #1b1a25 100%);
  height: 100vh;
}

.navbar {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 27px;
  margin-right: auto;
  margin-left: auto;
  position: fixed;
  width: 100%;
  z-index: 300;
}

.nav-right {
  display: flex;
  align-items: center;
}

.nav-title {
  color: white;
  font-weight: 900;
}

.nav-item {
  text-decoration: none;
  color: #fffffff6;
  margin: 0 15px;
  font-weight: 600;
  font-size: 15px;
}

.main {
  height: 100%;
  background-color: red;
}

.center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.center-column {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.sect {
  padding-top: 50px;
  background-color: #211d49;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.section-title {
  color: white;
  font-weight: 600;
  font-size: 3rem;
  text-align: center;
}

.logo {
  width: 100%;
  max-width: 350px;
  height: auto;
}

.icon-social {
  text-decoration: none;
  margin: 0 10px;
  transition: all 0.2s ease;
}

.icon-social:hover {
  transform: scale(1.1);
}

.para {
  color: white;
  font-weight: 400;
  margin-top: 5px;
}

.mods {
  margin-top: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

.marger {
  margin: 0 10px;
  background-color: transparent;
  margin-bottom: 10px;
}

.nav-logo {
  width: 100%;
  max-width: 48px;
  height: auto;
}

.social-button {
  height: 200px;
  width: 300px;
  display: flex;
  justify-content: center;
  align-content: center;
  border-radius: 15px;
  cursor: pointer;
  margin: 5px 10px;
  flex-direction: column;
  transition: all 0.2s ease;
  text-decoration: none;
}

.social-button:hover {
  transform: scale(1.1);
}

.discord {
  background-color: #7289da;
}

.skype {
  background-color: #00aff0;
}

.facebook {
  background-color: #3b5998;
}

.social-name {
  margin-top: 15px;
  text-align: center;
  font-weight: 800;
  color: white;
}

.cust-footer {
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;
  margin-top: 50px;
  margin-bottom: 20px;
  padding-bottom: 20px;
}

.copy-text {
  text-align: center;
  color: white;
}

.no-item {
  text-decoration: none;
}

@media (max-width: 767px) {
  .nav-logo {
    display: none;
  }

  .navbar {
    background-color: #1b1a25;
  }
}
</style>
